import React from 'react';
import { useInView } from '../utils/useItemsInView';
import RefinementHeader from './RefinementHeader';
export default function RefinementWidget(props) {
    const callbackRef = useInView(props.onViewed);
    return (React.createElement("div", { ref: callbackRef },
        React.createElement(RefinementHeader, { refinementOptions: props.data.refinementOptions, text: props.data.text, isActive: props.data.isActive, isDisabled: props.data.isDisabled, isOpened: true, useFilter: props.data.useFilter })));
}
